/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	CreateContentMutation$data as CreateContentMutation,
	CreateContentMutation$variables as CreateContentMutationVariables,
} from '../__generated__/CreateContentMutation.graphql.ts';

// Nested types extracted from Relay-generated types
import type { CreateContentMutation$data } from '../__generated__/CreateContentMutation.graphql.ts';
export type CreateContentMutation_createContentContextual_space = NonNullable<NonNullable<CreateContentMutation$data['createContentContextual']>['space']>;
export type CreateContentMutation_createContentContextual_links = NonNullable<NonNullable<CreateContentMutation$data['createContentContextual']>['links']>;
export type CreateContentMutation_createContentContextual_metadata_frontend = NonNullable<NonNullable<NonNullable<CreateContentMutation$data['createContentContextual']>['metadata']>['frontend']>;
export type CreateContentMutation_createContentContextual_metadata = NonNullable<NonNullable<CreateContentMutation$data['createContentContextual']>['metadata']>;
export type CreateContentMutation_createContentContextual = NonNullable<CreateContentMutation$data['createContentContextual']>;

// GraphQL input types re-exported from Relay artifact
export type { ContentSpecificCreateInput } from '../__generated__/CreateContentMutation.graphql.ts';

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum ConfluencePageSubType {
  LIVE = "LIVE",
}

export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}

